import { Navigate, Route, useLocation } from "react-router-dom"
import { WebsiteLayout } from "../layouts/WebsiteLayout"
import { Home } from "../pages/Home"
import { Login } from "../pages/Login"
import { Register } from "../pages/Register"
import { Cart } from "../pages/Cart"
import { Orders } from "../pages/Orders"
import { TagProducts } from "../pages/TagProducts"
import { ProductDetail } from "../pages/ProductDetail"
import { ForgotPassword } from "../pages/ForgotPassword"
import { ResetPassword } from "../pages/ResetPassword"
import { VerifyEmail } from "../pages/VerifyEmail"
import { WebsiteEnabledMiddleware } from "../middlewares/WebsiteEnabledMiddleware"
import { legacyWebsitePath } from "@/utilities/routePaths"

function LegacyWebsiteRedirect() {
  const { pathname, search, hash } = useLocation()
  return <Navigate to={legacyWebsitePath(pathname, search, hash)} replace />
}

export const websiteRoutes = (
  <>
    <Route path="/website/*" element={<LegacyWebsiteRedirect />} />
    <Route element={<WebsiteEnabledMiddleware />}>
      <Route path="/" element={<WebsiteLayout />}>
        <Route index element={<Home />} />
        <Route path="home" element={<Home />} />
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Register />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="verify-email" element={<VerifyEmail />} />
        <Route path="cart" element={<Cart />} />
        <Route path="orders" element={<Orders />} />
        <Route path="orders/:id" element={<Orders />} />
        <Route path="tag/:id" element={<TagProducts />} />
        <Route path="product/:sku" element={<ProductDetail />} />
      </Route>
    </Route>
  </>
)
